export default "__VITE_ASSET__BbuzZa7O__"